import Collapse from "@mui/material/Collapse";
import Thumbnail from "../thumbnail/Thumbnail";
import NameAndStatus from "../name-and-status/NameAndStatus";
import { StyledFileRow, StyledEditFormWrapper } from "../StyleComponents";
import { EditForm, SaveEditFormResponse, EntryMetadataStructure } from "@kaltura/mediaspace-shared-edit-entry";
import { FileRowProps } from "../FileRow";

export interface FileRowSimpleProps extends FileRowProps {
    isOpen: boolean;
    entryId: string;
    entryName: string;
    actions?: JSX.Element;
    onSubmitStarted: () => void;
    onSubmit: (data: SaveEditFormResponse) => void;
    formData: EntryMetadataStructure;
}

/**
 * simple file row  - suitable for single file upload
 */
export const FileRowSimple = (props: FileRowSimpleProps) => {
    const {
        className,
        isOpen,
        entryId,
        entryName,
        actions,
        onReadyForPublish,
        onCanSaveForm,
        onBeforeSubmit,
        onSubmitStarted,
        onSubmit,
        formData,
        fileInfo,
        editForm,
        editFormComponents,
        shouldClose,
        onClose,
        formId,
        showEditFormButtons,
        showCancelButton,
        saveButtonLabel,
        allowSaveUntouched,
    } = props;

    return (
        <div className={className}>
            <div id={`${entryId}-row`}>
                <StyledFileRow isOpen={isOpen} className={"kms-ds-upload-media-file-row"}>
                    <Thumbnail file={fileInfo} />
                    <NameAndStatus name={entryName} metadata={fileInfo.fileMetaData} />
                    {actions}
                </StyledFileRow>
            </div>
            <StyledEditFormWrapper>
                <Collapse in={isOpen} timeout="auto" unmountOnExit={true}>
                    <EditForm
                        entryIds={[entryId]}
                        onCanSaveForm={onCanSaveForm}
                        onReadyForPublish={onReadyForPublish}
                        onSubmitStarted={onSubmitStarted}
                        onSubmit={onSubmit}
                        formData={formData}
                        fieldsStructure={editForm}
                        components={editFormComponents}
                        shouldClose={shouldClose}
                        onClose={onClose}
                        formId={formId}
                        showEditFormButtons={showEditFormButtons}
                        showCancelButton={showCancelButton}
                        saveButtonLabel={saveButtonLabel}
                        allowSaveUntouched={allowSaveUntouched}
                        onBeforeSubmit={onBeforeSubmit}
                    />
                </Collapse>
            </StyledEditFormWrapper>
        </div>
    );
};
